import { Attention, Typography } from "@optimizely/axiom";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";

export const GenerativeAIHipaaWarning = () => {
    const { opalName } = useOpalBranding();

    return (
        <Attention type="warning" className="push-double--top">
            <Typography type="body" className="flex align-items-center">
                {opalName} settings are not available for HIPAA compliant organizations. Please contact support if you
                have questions.
            </Typography>
        </Attention>
    );
};

GenerativeAIHipaaWarning.displayName = "GenerativeAIHipaaWarning";
